export const GET_ENVIRONMENTS_REQUEST = 'GET_ENVIRONMENTS_REQUEST';
export const GET_ENVIRONMENTS_SUCCESS = 'GET_ENVIRONMENTS_SUCCESS';
export const GET_ENVIRONMENTS_FAILED = 'GET_ENVIRONMENTS_FAILED';

export const GET_ENVIRONMENT_DETAIL_REQUEST = 'GET_ENVIRONMENT_DETAIL_REQUEST';
export const GET_ENVIRONMENT_DETAIL_SUCCESS = 'GET_ENVIRONMENT_DETAIL_SUCCESS';
export const GET_ENVIRONMENT_DETAIL_FAILED = 'GET_ENVIRONMENT_DETAIL_FAILED';

export const CREATE_ENVIRONMENT_REQUEST = 'CREATE_ENVIRONMENT_REQUEST';
export const CREATE_ENVIRONMENT_SUCCESS = 'CREATE_ENVIRONMENT_SUCCESS';
export const CREATE_ENVIRONMENT_FAILED = 'CREATE_ENVIRONMENT_FAILED';

export const UPDATE_ENVIRONMENT_REQUEST = 'UPDATE_ENVIRONMENT_REQUEST';
export const UPDATE_ENVIRONMENT_SUCCESS = 'UPDATE_ENVIRONMENT_SUCCESS';
export const UPDATE_ENVIRONMENT_FAILED = 'UPDATE_ENVIRONMENT_FAILED';

export const DELETE_ENVIRONMENT_REQUEST = 'DELETE_ENVIRONMENT_REQUEST';
export const DELETE_ENVIRONMENT_SUCCESS = 'DELETE_ENVIRONMENT_SUCCESS';
export const DELETE_ENVIRONMENT_FAILED = 'DELETE_ENVIRONMENT_FAILED';

export const RESET_ENVIRONMENT = 'RESET_ENVIRONMENT';
